module.exports = __webpack_public_path__ + "img/becklogo2F.c5f53f31.jpg";